export default "__VITE_ASSET__3d07c1a0__"